// extracted by mini-css-extract-plugin
export default {"userView":"UserView_userView__vXb9b"};